//TODO (ishan) make a Chat folder under components and put this there
export type Size = "small" | "large"

export const getUserImgClassName = (size: Size) =>
  size === "small" ? "w-4 h-4" : "w-10 h-10"
export const getSpaceClassName = (size: Size) =>
  size === "small" ? "gap-2" : "gap-4"
export const getFontSizeClassName = (size: Size) =>
  size === "small" ? "text-sm" : "text-4xl"
